var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-table',{attrs:{"data":_vm.tableData}},[_c('vxe-table-column',{attrs:{"field":"branchName","title":"承运主体"}}),_c('vxe-table-column',{attrs:{"field":"taxPoint","title":"服务费率(%)"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }